import { STAR_RATINGS } from './constants';

export type StarRating = typeof STAR_RATINGS[number] | null;

export function isStarRating(rating: unknown): rating is StarRating {
  return (
    typeof rating == 'string' && STAR_RATINGS.includes(rating as StarRating)
  );
}
